import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

const colorMap: Record<string, { bg: string; iconBg: string; text: string; border: string }> = {
  primary: {
    bg: 'hover:bg-primary-50',
    iconBg: 'bg-primary-100',
    text: 'text-primary-600',
    border: 'border-primary-200/60',
  },
  accent: {
    bg: 'hover:bg-accent-50',
    iconBg: 'bg-accent-100',
    text: 'text-accent-600',
    border: 'border-accent-200/60',
  },
  secondary: {
    bg: 'hover:bg-secondary-50',
    iconBg: 'bg-secondary-100',
    text: 'text-secondary-600',
    border: 'border-secondary-200/60',
  },
};

export default function CategoryShowcase() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">热门分类</h2>
          <p className="text-sm text-foreground-500 mt-2">六大内容板块，满足你的多元兴趣</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.id}
                to={`/category?tab=${cat.id}`}
                className={`group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg bg-background-50 border ${colors.border} ${colors.bg} transition-all duration-200 cursor-pointer`}
              >
                <div className={`w-12 h-12 md:w-14 md:h-14 rounded-full ${colors.iconBg} flex items-center justify-center`}>
                  <i className={`${cat.icon} text-xl md:text-2xl ${colors.text}`} />
                </div>
                <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{cat.name}</span>
                <span className="text-xs text-foreground-400">{cat.count.toLocaleString()}+ 内容</span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}